import SelectList from "types/SelectList";

const TRIANGULATION_OPTIONS: SelectList = [
  { value: "DDP", label: "DDP" },
  { value: "DAP ", label: "DAP " },
  { value: "DDU", label: "DDU" },
];

export default TRIANGULATION_OPTIONS;
